import { render, staticRenderFns } from "./QueryAnswerDialog.vue?vue&type=template&id=52670daa&v-if=completeQuery.id"
import script from "./QueryAnswerDialog.vue?vue&type=script&lang=ts"
export * from "./QueryAnswerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports